const langDrawer = document.querySelector('[data-name="lang-curr-drawer"]');
const langBtnSwitcher = document.querySelector('[data-name="lang-mobile-switch"]');

function toggleLangDrawer() {
    langDrawer.classList.toggle("active");
}

function hideDrawer(e) {
    if (e.target.classList.contains("active")) {
        langDrawer.classList.remove("active");
    }
}

document.querySelector('[data-name="lang-btn-toggle"]').addEventListener("click", toggleLangDrawer);
document.querySelector('[data-name="lang-curr-drawer"]').addEventListener("click", hideDrawer);

// Toggle disclosure panel (used both for button click and for clicking the item area)
function toggleDrawerDisclosure(button, panel, localizationForm) {
    if (!button || !panel) return;
    const isOpen = button.getAttribute('aria-expanded') === 'true' || !panel.hasAttribute('hidden');

    if (isOpen) {
        if (localizationForm && typeof localizationForm.hidePanel === 'function') {
            localizationForm.hidePanel();
        } else {
            button.setAttribute('aria-expanded', 'false');
            panel.setAttribute('hidden', '');
            document.body.classList.remove('overflow-hidden-mobile');
        }
    } else {
        if (localizationForm && typeof localizationForm.openSelector === 'function') {
            localizationForm.openSelector();
        } else {
            button.setAttribute('aria-expanded', 'true');
            panel.removeAttribute('hidden');
            if (!document.body.classList.contains('overflow-hidden-tablet')) {
                document.body.classList.add('overflow-hidden-mobile');
            }
        }
    }
}

// Make entire .lang-curr-drawer__item clickable to toggle disclosure; handle button click (localization-form.js may not be loaded)
function setupDrawerItemClickHandlers() {
    const drawerItems = document.querySelectorAll('.lang-curr-drawer__item');

    drawerItems.forEach((item) => {
        item.addEventListener('click', function (e) {
            // Don't toggle when clicking inside the open list (user is choosing language/country or clicking empty space)
            if (e.target.closest('.disclosure__list-wrapper')) {
                return;
            }

            // Don't run our toggle when clicking the button – the button has its own handler (localization-form)
            // Otherwise we'd double-toggle: openSelector opens, then our handler would close it
            if (e.target.closest('.disclosure__button')) {
                return;
            }

            const button = item.querySelector('.disclosure__button');
            const panel = item.querySelector('.disclosure__list-wrapper');
            const localizationForm = item.closest('localization-form');

            // Click on button or anywhere on the item (e.g. label) – toggle disclosure
            if (button && panel) {
                toggleDrawerDisclosure(button, panel, localizationForm);
            }
        });
    });
}

// Wait for DOM to be ready and localization-form to be initialized
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupDrawerItemClickHandlers);
} else {
    // DOM is already ready, but wait a bit for custom elements to initialize
    setTimeout(setupDrawerItemClickHandlers, 100);
}

function changeCurrentLangAndCurrInSidebar() {
    if (document.URL.indexOf("/de") > -1) {
        langBtnSwitcher.innerHTML = "DE";
    } else if (document.URL.indexOf("/pl") > -1) {
        langBtnSwitcher.innerHTML = "PL";
    } else if (document.URL.indexOf("/fr") > -1) {
        langBtnSwitcher.innerHTML = "FR";
    } else if (document.URL.indexOf("/it") > -1) {
        langBtnSwitcher.innerHTML = "IT";
    } else if (document.URL.indexOf("/es") > -1) {
        langBtnSwitcher.innerHTML = "ES";
    } else if (document.URL.indexOf("/nl") > -1) {
        langBtnSwitcher.innerHTML = "NL";
    } else if (document.URL.indexOf("/sv") > -1) {
        langBtnSwitcher.innerHTML = "SV";
    } else {
        langBtnSwitcher.innerHTML = "EN";
    }
}
// changeCurrentLangAndCurrInSidebar();